export default __webpack_public_path__ + "static/media/toy13.7cf43968.jfif";